export default __webpack_public_path__ + "static/media/PdfIcon.74a25d7b.png";